exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index-modelInner-tK_j3{width:100%;margin-top:8px}.index-modelContentLine-263Sg{width:100%;height:28px;display:flex;align-items:center;margin-bottom:24px}.index-optionStyle-2-wLC{width:124px}.index-gridSpaceLabel-2eDI0{width:42px;min-width:-webkit-max-content;min-width:max-content}.index-contentLineSpace-2yo5A{width:10px;margin-top:10px}.index-selectStyle-2nS42{height:28px;width:146px}.index-numberInput-2ZqKp{margin-left:14px}.index-subTitle-3DB19{opacity:.4;font-size:14px;font-weight:400;font-stretch:normal;font-style:normal;line-height:1.57;letter-spacing:normal;color:#000;margin-bottom:20px}.index-checkFontStyle-1f6eq{font-weight:500}", ""]);

// Exports
exports.locals = {
	"modelInner": "index-modelInner-tK_j3",
	"modelContentLine": "index-modelContentLine-263Sg",
	"optionStyle": "index-optionStyle-2-wLC",
	"gridSpaceLabel": "index-gridSpaceLabel-2eDI0",
	"contentLineSpace": "index-contentLineSpace-2yo5A",
	"selectStyle": "index-selectStyle-2nS42",
	"numberInput": "index-numberInput-2ZqKp",
	"subTitle": "index-subTitle-3DB19",
	"checkFontStyle": "index-checkFontStyle-1f6eq"
};